import { render } from "./EmailChengeModal.vue?vue&type=template&id=e9e32712&ts=true&lang=pug"
import script from "./EmailChengeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailChengeModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__